import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse, apiError } from '../schemas/common.schema';

const c = initContract();
const dateish = z.union([z.string(), z.date()]).optional();

const LessonCourseInfoSchema = z.object({
  _id: z.string(),
  course_title: z.string().optional(),
  course_image: z.string().optional(),
  course_url_token: z.string().optional(),
  course_description: z.string().optional(),
});

export const LessonResponseSchema = z.object({
  _id: z.string(),
  lesson_title: z.string().optional(),
  lesson_summary: z.string().optional(),
  lesson_objectives: z.array(z.string()).optional(),
  lesson_token: z.string().optional(),
  lesson_order: z.number().optional(),
  lesson_minutes: z.number().optional(),
  lesson_topic: z.string().optional(),
  lesson_created_at: dateish,
  lesson_modified_at: dateish,
  lesson_content: z.array(z.any()).optional(),
  course_id: z.string().optional(),
  course: LessonCourseInfoSchema.optional(),
});

const getLessonsQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().optional(),
  course_id: z.string().optional(),
  course_url_token: z.string().optional(),
});

export const lessonsContract = c.router({
  getLessons: {
    method: 'GET',
    path: '/lessons',
    query: getLessonsQuery,
    responses: { 200: apiResponse(z.array(LessonResponseSchema)) },
  },
  getLessonById: {
    method: 'GET',
    path: '/lessons/:lesson_id',
    pathParams: z.object({ lesson_id: z.string() }),
    responses: { 200: apiResponse(LessonResponseSchema), 404: apiError },
  },
});

export type LessonResponseDto = z.infer<typeof LessonResponseSchema>;
